const scrollbarContextKey = Symbol("scrollbarContextKey");

export { scrollbarContextKey };
//# sourceMappingURL=constants.mjs.map
